export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon-waiting.3fb2cd40.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};